/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespLayout_viewer = {
    readonly itemSearch: {
        readonly pageType: string | null;
        readonly displayUriRef: string | null;
        readonly " $fragmentRefs": FragmentRefs<"useSearchCorrections_itemSearch" | "SbSharedRefetchContainer_itemSearch" | "SbSharedTrackingContainer_itemSearch" | "SbSharedHead_itemSearch" | "SbRespComponents_itemSearch">;
    } | null;
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"SbSharedTrackingContainer_user" | "SbRespComponents_user">;
    } | null;
    readonly regionalInfo?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefetchContainer_regionalInfo">;
    } | null> | null;
    readonly shippingFilters?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefetchContainer_shippingFilters" | "SbRespComponents_shippingFilters">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespComponents_viewer">;
    readonly " $refType": "SbRespLayout_viewer";
};
export type SbRespLayout_viewer$data = SbRespLayout_viewer;
export type SbRespLayout_viewer$key = {
    readonly " $data"?: SbRespLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespLayout_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v1 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v2 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
};
return {
  "kind": "Fragment",
  "name": "SbRespLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "hasPersonalizedFilter",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": "0"
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "page",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "eligibleAbTest",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "regions",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "disableForceFacet",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchSb",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemSearch",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "disableForceFacet",
          "variableName": "disableForceFacet"
        },
        {
          "kind": "Variable",
          "name": "eligibleAbTest",
          "variableName": "eligibleAbTest"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "localeOrigin",
          "variableName": "localeOrigin"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "regions",
          "variableName": "regions"
        },
        (v0/*: any*/)
      ],
      "concreteType": "ItemSearchQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "pageType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayUriRef",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "useSearchCorrections_itemSearch",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "searchCorrections",
              "storageKey": null,
              "args": null,
              "concreteType": "SearchCorrectionsType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "semanticSearchTerm",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "classificationLevel",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "classificationSearchTerm",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "appliedFilters",
              "storageKey": null,
              "args": null,
              "concreteType": "SearchBrowseParsedParam",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "values",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SearchBrowseParsedParamValue",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "urlLabel",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedRefetchContainer_itemSearch",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedTrackingContainer_itemSearch",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedHead_itemSearch",
          "args": null
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "fetchSb",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_itemSearch",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespComponents_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_user",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasPersonalizedFilter",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "regionalInfo",
          "storageKey": null,
          "args": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "concreteType": "RegionalInfo",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_regionalInfo",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shippingFilters",
          "storageKey": null,
          "args": [
            (v1/*: any*/),
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "concreteType": "ShippingFilterType",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_shippingFilters",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_shippingFilters",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '94cfc41c32e337a5a2c2bf8393f6021a';
export default node;
